import { render, staticRenderFns } from "./Umowa.vue?vue&type=template&id=764f1179&"
import script from "./Umowa.vue?vue&type=script&lang=js&"
export * from "./Umowa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports